import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAppSelector } from 'slices/commonSelectors';
import { selectCombinedUser } from 'slices/commonSelectors';
import { WorkspaceType } from 'types/workspace';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { Channel } from 'types/channels';

const keys = {
  customTeamTemplate: 'customTeamTemplate',
};

type SaveCustomTeamTemplateInput = {
  workspaceType: WorkspaceType;
  workspaceId: UUID;
  channels: Channel[];
  tenantId: UUID;
  description?: string;
  label?: string;
};

export const useSaveCustomTeamTemplate = () => {
  const queryClient = useQueryClient();
  const userEmail = useAppSelector(selectCombinedUser).email_address;

  return useMutation<any, any, SaveCustomTeamTemplateInput>({
    mutationFn: async ({
      workspaceType,
      tenantId,
      channels,
      description,
      label,
    }) => {
      const response = await axios(config.apiGateway.customTeamTemplates, {
        method: 'POST',
        data: {
          workspaceType,
          tenantId,
          channels,
          userEmail,
          description,
          label,
        },
      });
      return response?.data;
    },
    onSuccess: ({ message }, { workspaceType, workspaceId }) => {
      toast.success(message);
      queryClient.invalidateQueries({
        queryKey: [keys.customTeamTemplate, workspaceType, workspaceId],
      });
    },
    onError: (error) => {
      toast.error(error.response.data.error);
    },
  });
};
